import Vue from 'vue'
import Vuetify from 'vuetify/lib'
// eslint-disable-next-line import/extensions
import et from '@/i18n/et'
import en from '@/i18n/en'
import lv from '@/i18n/lv'
import lt from '@/i18n/lt'

Vuetify.config.silent = process.env.NODE_ENV === 'production'

Vue.use(Vuetify)

const theme = {
  primary: '#FFC41F',
  secondary: '#293142',
  accent: '#fc855a',
  error: '#c8697e',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
}

export default new Vuetify({
  lang: {
    locales: {
      et,
      en,
      lv,
      lt
    },
    current: 'en'
  },
  theme: {
    themes: {
      dark: theme,
      light: theme
    }
  }
})
